import { Controller } from "@hotwired/stimulus"
import {
  TRACKING_CONSENT_ACCEPTED,
  TRACKING_CONSENT_ACCEPTED_EVENT,
  TRACKING_CONSENT_COOKIE,
  TRACKING_CONSENT_DECLINED,
  trackingConsentState
} from "../lib/analytics"

const ONE_YEAR = 60 * 60 * 24 * 365
const ANALYTICS_COOKIE = "_ford_analytics_session"
const VIDEO_FINGERPRINT_KEY = "ford_guia_fp"

export default class extends Controller {
  connect() {
    if (trackingConsentState()) this.hide()
  }

  accept() {
    this.setCookie(TRACKING_CONSENT_ACCEPTED, ONE_YEAR)
    this.hide()
    document.dispatchEvent(new CustomEvent(TRACKING_CONSENT_ACCEPTED_EVENT))
  }

  decline() {
    this.setCookie(TRACKING_CONSENT_DECLINED, ONE_YEAR)
    this.deleteCookie(ANALYTICS_COOKIE)
    try { localStorage.removeItem(VIDEO_FINGERPRINT_KEY) } catch (_) { /* storage blocked */ }
    this.hide()
  }

  setCookie(value, maxAge) {
    document.cookie = [
      `${encodeURIComponent(TRACKING_CONSENT_COOKIE)}=${encodeURIComponent(value)}`,
      "Path=/",
      `Max-Age=${maxAge}`,
      "SameSite=Lax",
      window.location.protocol === "https:" ? "Secure" : null
    ].filter(Boolean).join("; ")
  }

  deleteCookie(name) {
    document.cookie = [
      `${encodeURIComponent(name)}=`,
      "Path=/",
      "Max-Age=0",
      "SameSite=Lax",
      window.location.protocol === "https:" ? "Secure" : null
    ].filter(Boolean).join("; ")
  }

  hide() {
    this.element.remove()
  }
}
